import React, { useEffect, useState } from 'react';
import * as Styled from './ActionResultOverlay.styled';
import { resultItem } from '../../../proptypes/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { setVisibleAction } from '../../../slices/chat/ChatSlice';
import {
  IconLabelButtonSizes,
  IconLabelButtonTypes,
} from '../IconLabelButton/IconLabelButtonUtil';
import { useTooltipState, Tooltip, TooltipReference } from 'reakit';
import VirtiTooltip from '../../atoms/VirtiTooltip/VirtiTooltip';
import { usePrevious } from '../../../utility/StateHooks';
import { Icon } from '@virtidev/toolbox';
import { useVHTypeConfig } from '../../vh-types/vhTypeHooks';

const ActionResultOverlay = (props) => {
  const dispatch = useDispatch();
  const visibleAction = useSelector((state) => state.chat?.visibleAction);
  const prevVisibleAction = usePrevious(visibleAction);
  const [visible, setVisible] = useState(true);
  const tooltipData = useTooltipState({ placement: 'top-end' });
  useEffect(() => {
    if (visibleAction && visibleAction !== prevVisibleAction) {
      setVisible(true);
    }
  }, [visibleAction, prevVisibleAction]);
  const vhTypeConfig = useVHTypeConfig();
  return (
    <Styled.Wrapper>
      <Styled.SlideButtonWrapper>
        <TooltipReference {...tooltipData} as="span">
          <Styled.SlideButton
            type={
              visible ? IconLabelButtonTypes.BLUE : IconLabelButtonTypes.GREY
            }
            size={IconLabelButtonSizes.SMALL}
            onClick={() => setVisible(!visible)}
            visible={visible}
          >
            <Styled.IconWrapper>
              <Icon icon={vhTypeConfig.actionIcon} />
            </Styled.IconWrapper>
          </Styled.SlideButton>
        </TooltipReference>
      </Styled.SlideButtonWrapper>
      <VirtiTooltip tooltipData={tooltipData}>
        {visible ? 'Hide' : 'Show'} latest action
      </VirtiTooltip>
      <Styled.ResultItemWrapper visible={visible}>
        <Styled.StyledResultItem
          onClose={() => dispatch(setVisibleAction(null))}
          onCloseDisabled={!!visibleAction}
          highlighted={false}
          resultItem={props.resultItem}
        />
      </Styled.ResultItemWrapper>
    </Styled.Wrapper>
  );
};

ActionResultOverlay.propTypes = {
  resultItem: resultItem.isRequired,
};

export default ActionResultOverlay;
